import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";

export abstract class ISupplierCategoryApi {
	abstract getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
